module.exports = __webpack_public_path__ + "img/scorpione-white.6a356214.png";